import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '@env/environment';
import { AuthenticationService } from '@app/core';
import { CredentialsService } from '@app/core';

export interface ThemeTokens {
  [key: string]: string;
}

export interface ReservationThemeData {
  clientId: number;
  presetName: string;
  themeTokens: ThemeTokens;
  backgroundColor?: string;
  mainColor?: string;
  primaryColor?: string;
  primaryFont?: string;
  secondaryFont?: string;
  formBackgroundColor?: string;
}

export const DEFAULT_THEME: ReservationThemeData = {
  clientId: null,
  presetName: 'Standard',
  themeTokens: {}
};

@Injectable({ providedIn: 'root' })
export class ReservationThemeService {
  constructor(
    private http: HttpClient,
    private authService: AuthenticationService,
    private credentialsService: CredentialsService
  ) {}

  private get headers(): HttpHeaders {
    const cred = this.credentialsService.credentials;
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + cred.token
    });
  }

  getWidgetTheme(): Observable<ReservationThemeData> {
    return this.http
      .get<ReservationThemeData>(
        environment.serverUrl + `reservation/widget-style/` + this.authService.activeClientId,
        {
          headers: this.headers
        }
      )
      .pipe(
        map((data: any) => ({
          ...data,
          themeTokens: data.themeTokens || {}
        })),
        catchError(() => of({ ...DEFAULT_THEME, clientId: this.authService.activeClientId }))
      );
  }

  saveWidgetTheme(data: Partial<ReservationThemeData>): Observable<ReservationThemeData> {
    const payload = {
      ...data,
      clientId: this.authService.activeClientId
    };
    return this.http
      .put<ReservationThemeData>(environment.serverUrl + `reservation/save-widget-style/`, payload, {
        headers: this.headers
      })
      .pipe(
        map((data: any) => ({
          ...data,
          themeTokens: data.themeTokens || {}
        }))
      );
  }
}
